import { useEffect } from "react";
import { Select } from "../../../core/components/ui/input";
import { Icon } from "../../../core/components/ui/icon";
import { useTenantStore } from "../stores/tenant";

/** Sélecteur d'établissement courant, rendu dans la barre du haut. */
export function TenantSwitcher() {
  const { available, currentTenantId, setTenant, load } = useTenantStore();

  useEffect(() => {
    load().catch(() => {});
  }, [load]);

  if (available.length === 0) return <span className="topbar__empty">Aucun établissement</span>;

  return (
    <label className="topbar__pill">
      <span className="topbar__pill-icon">
        <Icon name="building" size={16} />
      </span>
      <Select
        className="topbar__pill-select"
        value={currentTenantId ?? ""}
        onChange={(e) => setTenant(e.target.value)}
        aria-label="Établissement courant"
      >
        {available.map((t) => (
          <option key={t.id} value={t.id}>
            {t.name}
          </option>
        ))}
      </Select>
    </label>
  );
}
